export const logotipoSVG = `${process.env.PUBLIC_URL || ''}/assets/logos/cross-min-logo.svg`
export const isotipoSVG = `${process.env.PUBLIC_URL || ''}/assets/logos/cross-Logo-Login.svg`

export const angleLeftSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/angle-line-left.svg`
export const angleRightSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/angle-line-rigth.svg`
export const angleDownSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/angle-down-line.svg`
export const angleUpSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/angle-up-line.svg`

export const restartSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/restart.svg`
export const playCircleSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/play_circle.svg`
export const pauseCircleSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/pause_circle.svg`
export const stopCircleSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/stop_circle.svg`
export const micSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/mic.svg`
export const micOffSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/mic_off.svg`
export const cancelSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/close.svg`
export const logoutSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/logout.svg`
export const plusSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/plus.svg`
export const addTransitionSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/add-transition.svg`
export const circlePlusSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/circle-plus.svg`
export const minusSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menos.svg`
export const checkCircleSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/check-circle-line.svg`
export const errorCircleSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/times-circle-line.svg`
export const userSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-usuario.svg`
export const apikeySVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-key.svg`
export const threeDotsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/three-dots-svgrepo-com.svg`
export const locationSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/location.svg`
export const closeRoundSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/close-round.svg`
export const subTaskArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/subtask-middle-arrow.svg`
export const subTaskBorderHeaderSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/subtask-border-header.svg`
export const subTaskLastItemSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/subtask-last-item.svg`
export const chatsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/chats.svg`
export const ticketsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/tickets.svg`

export const configurationSVG = `${process.env.PUBLIC_URL || ''}/assets/images/ilustracion-perfiles.svg`

export const settingSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-ajustes.svg`
export const webConfigurationSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-web.svg`

export const famaleSVG = `${process.env.PUBLIC_URL || ''}/assets/images/female.svg`
export const maleSVG = `${process.env.PUBLIC_URL || ''}/assets/images/male.svg`
export const peopleSVG = `${process.env.PUBLIC_URL || ''}/assets/images/people.svg`
export const usersBackgroundSVG = `${process.env.PUBLIC_URL || ''}/assets/images/users.svg`

export const exclamationSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/exclamation.svg`
export const messageSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/message.svg`
export const noteSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-casos.svg`
export const dashboardSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-dash.svg`
export const reportsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-reportes.svg`
export const socialSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-social.svg`
export const newMessagesSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/messageUnreadIcon.svg`
export const managmentSVG = `${process.env.PUBLIC_URL || ''}/assets/images/managment.svg`
export const channelsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-canal.svg`
export const socialMentionSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/public.svg`
export const facebookFeedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-feed.svg`
export const socialMessageSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-message.svg`
export const emailSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/mail.svg`
export const sendGridSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/sendgrid.svg`
export const epecSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/epec.svg`
export const epecLoginSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/epec-login.svg`
export const epecJPG = `${process.env.PUBLIC_URL || ''}/assets/icons/epec.jpg`
export const userUnknownJPG = `${process.env.PUBLIC_URL || ''}/assets/images/unknown-user.png`
export const youtubeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/youtube.svg`
export const noImageSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/error-image.svg`
export const clipSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/clip.svg`
export const facebookOfficialLogoPNG =
	`${process.env.PUBLIC_URL || ''}/assets/icons/facebook_official_logo.png`
export const webchatSetSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/chatweb.svg`
export const webchatStep1SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-web.svg`
export const webchatStep2SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-copy.svg`
export const webchatStep3SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-personalizar.svg`
export const webchatStep4SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-datos.svg`
export const webchatStep5SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-chat.svg`
export const webchatOmuniIcon = `${process.env.PUBLIC_URL || ''}/assets/icons/omni webchat.svg`
export const iconCopyBlueSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-copy-blue.svg`
export const appStoreSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/app_store.svg`
export const playStoreSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/play_store.svg`

export const verifiedTwitterSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/verified-twitter.svg`
export const retweetSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/retweet.svg`

export const followerSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/follower-icon.svg`
export const notFollowerSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/not-follower-icon.svg`

export const verifiedIconSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-verified.svg`

//transparent channels icons
export const facebookTransparentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/facebook-transparent.svg`
export const whatsAppTransparentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/whatsapp-transparent.svg`
export const linkedInTransparentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/linkedIn-transparent.svg`
export const emailTransparentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/mail-transparent.svg`
export const instagramTransparentSVG =
	`${process.env.PUBLIC_URL || ''}/assets/icons/instagram-transparent.svg`
export const slackTransparentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/slack-transparent.svg`
export const telegramTransparentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/telegram-transparent.svg`
export const mercadoLibreTransparentSVG =
	`${process.env.PUBLIC_URL || ''}/assets/icons/meli_logo_transparent.svg`
export const webchatTransparentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/webchat-transparent.svg`

export const webchatArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/arrow-webchat.svg`
export const areasSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-areas.svg`
export const profilesSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-perfil.svg`
export const comercialSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-comercial.svg`
export const networkSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-redes.svg`
export const supportSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-soporte.svg`
export const generalSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-general.svg`
export const searchSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/search-icon.svg`
export const templateSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-template.svg`
export const contractOutlinedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/contract.svg`
export const numberSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/number.svg`
export const flagSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/flag-fine-line.svg`
export const reasonSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/reason.svg`
export const typeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/type.svg`

export const agentMenuSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/agent-menu.svg`
export const workflowMenuSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/workflow-menu.svg`

export const contactsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-contactos.svg`
export const webSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-webform.svg`
export const customReportSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/reporte-personalizado.svg`
export const sampleAvatarSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/sampleAvatar.svg`
export const closedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-closed.svg`
export const pendingSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-pendings.svg`
export const derivedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-delivered.svg`
export const inProgressSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-in-progress.svg`
export const openedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon_opened.svg`
export const newSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-new.svg`
export const location2SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-location.svg`
export const answerSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/answer.svg`
export const commentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/comment.svg`
export const commentSocialOutgoingSVG =
	`${process.env.PUBLIC_URL || ''}/assets/icons/comment-social-outgoing.svg`
export const templateOptionSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/template-option.svg`
export const labelOutlineSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/label-outline.svg`
export const folderOutlineSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/folder-outline.svg`

export const medal1SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-ranking-01.svg`
export const medal2SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-ranking-02.svg`
export const medal3SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-ranking-03.svg`
export const rankingSVG = `${process.env.PUBLIC_URL || ''}/assets/images/ilustracion ranking.svg`
export const filterSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/filter.svg`
export const filterIconSVG = `${process.env.PUBLIC_URL || ''}/assets/images/filter-cases.svg`
export const filterStripesSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/filter-cases.svg`

export const crosshairsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/crosshairs-gps.svg`
export const likeFacebookSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-like.svg`
export const likeFacebookSelectedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-like-selected.svg`
export const dislikeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-dislike.svg`
export const dislikeSelectedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-dislike-selected.svg`
export const shareSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/share.svg`
export const shareSelectedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/share-selected.svg`
export const commentFacebookSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-comment.svg`
export const emojiPickerSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/emoji-picker.svg`
export const filePickerSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/picker-file.svg`
export const fileDocumentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/file-document.svg`
export const postSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/post.svg`

export const notificationSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-notificaciones.svg`
export const notificationBellSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/bell.svg`
export const telephoneSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-telefono.svg`
export const notNotificationSVG =
	`${process.env.PUBLIC_URL || ''}/assets/images/Illustration-no-notifications.svg`

export const trashSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/trash-icon.svg`
export const trashGraySVG = `${process.env.PUBLIC_URL || ''}/assets/icons/trash-icon-gray.svg`
export const deleteIconSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/delete.svg`
export const copySVG = `${process.env.PUBLIC_URL || ''}/assets/icons/copy-icon.svg`
export const copyButtonSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/copy.svg`
export const notPublicationSVG = `${process.env.PUBLIC_URL || ''}/assets/images/ilustracion-publicaciones.svg`
export const notStreamSVG = `${process.env.PUBLIC_URL || ''}/assets/images/ilustracion-live-stream.svg`

export const alcanceSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/panel-alcance.svg`
export const audienciaSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/panel-audiencia.svg`
export const interaccionesSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/panel-interacciones.svg`
export const recibidosSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/panel-mensajes-recibidos.svg`
export const resumenSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/panel-resumen.svg`

export const positiveSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-positivo.svg`
export const negativeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-negativo.svg`
export const neutralSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-neutral.svg`
export const omuniSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/omuni_logo.svg`
export const omuniGreenSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/omuni.svg`
export const omuniWithBackgroundSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/logo-omuni-iso.png`
export const omuniWithNameSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/omuni_logo_with_name.svg`

export const selectAssignedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/agent-assigned.svg`
export const areaSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/area.svg`
export const prioritySVG = `${process.env.PUBLIC_URL || ''}/assets/icons/priority.svg`
export const historySVG = `${process.env.PUBLIC_URL || ''}/assets/icons/history.svg`
export const selectStatusSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/status.svg`
export const tipificationSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-tipificacion.svg`

export const subtasksSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/subtasks.svg`
export const contactSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/contact.svg`

export const ilustrationProfiles = `${process.env.PUBLIC_URL || ''}/assets/images/ilustrationProfileSvg.svg`
export const camSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-line-cam.svg`
export const expandSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/iso-expandir.svg`
export const contractSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/iso-contraer.svg`
export const archiveSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-archivo.svg`
export const audioSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-audio.svg`
export const videoSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-video.svg`
export const stateSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/state.svg`
export const statisticsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-estadisticas.svg`

export const casemapSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/casemap.svg`
export const contactImageSVG = `${process.env.PUBLIC_URL || ''}/assets/images/ilustracion-perfiles.svg`
export const apiKeyImageSVG = `${process.env.PUBLIC_URL || ''}/assets/images/ilustracion-key.svg`
export const areasImageSVG = `${process.env.PUBLIC_URL || ''}/assets/images/ilustracion-areas.svg`
export const profilesNotImageSVG =
	`${process.env.PUBLIC_URL || ''}/assets/images/ilustracionNoImageProfiles.svg`

export const preferencesSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/menu-preferencias.svg`
export const mundoCreditoSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/mundo-credito.svg`
export const infoSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/info.svg`
export const collapsableArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/collapsable.svg`

export const spinnerSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/spinner.svg`
export const saveSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/save.svg`
//TODO:MAKE save2SVG the only one saveSVG (some buttons use save.svg instead of save2.svg)
export const save2SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/save2.svg`
export const closeCaseSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/close-case.svg`
export const calendarSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/calendar.svg`
export const calendarStatisticSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/calendar_statistic.svg`

export const sendSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/send.svg`
export const sendMessageSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/send-message.svg`

export const alertSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/alert-triangle.svg`
export const cleanSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/clean.svg`
export const addButtonSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/add.svg`
export const cancelButtonSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/cerrar_.svg`
export const noContactImage = `${process.env.PUBLIC_URL || ''}/assets/icons/contactSearchImage.svg`
export const searchButton = 'assets/icons/icons-search.svg'
export const arrowGrowRightSVG = 'assets/icons/arrow-grow-right.svg'

export const eyeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/ver.svg`
export const segmentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/segmentar.svg`
export const notificationSuccessSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-ok-notification.svg`
export const notificationErrorSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-error-notification.svg`
export const notificationInfoSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-info-notification.svg`
export const notificationWarningSVG =
	`${process.env.PUBLIC_URL || ''}/assets/icons/icon-warning-notification.svg`
export const notificationCloseSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-close-notification.svg`
export const answerMessageSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/answer-message.svg`
export const socialCommentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/socialComment.svg`
export const privateSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/private.svg`
export const publicSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-public.svg`
export const associateSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/link.svg`
export const editSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/edit.svg`
export const unlinkSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/unlink.svg`

export const replyToSolidSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/responder-solid-01.svg`

export const testingSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-test.svg`
export const stagingSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-stag.svg`
export const certifiedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/certificate.svg`

export const interactionShareSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/share-interactions.svg`
export const interactionLikeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/like.svg`
export const interactionLoveSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/love.svg`
export const interactionCommentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/comment-interactions.svg`

export const goBackArrow = `${process.env.PUBLIC_URL || ''}/assets/icons/back-01.svg`
export const exportReportSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/export_report.svg`

export const workflowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/workflow.svg`
export const downloadSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/descargar.svg`

export const botSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon-bot.svg`
export const ilustrationBots = `${process.env.PUBLIC_URL || ''}/assets/images/Illustration-bot.svg`
export const denwaSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/logo_denwa.svg`

export const agentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/agente.svg`

export const rulesSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/rules.svg`
export const ruleIllustrationSVG = `${process.env.PUBLIC_URL || ''}/assets/images/Illustration-rules.svg`

export const checkSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/check.svg`
export const cruzSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/cruz.svg`

export const casesNoLikeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/like twitter line.svg`
export const casesLikeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/like twitter solid.svg`

export const companySettingsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon_company.svg`
export const domainSettingsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon_dominio.svg`
export const passwordSettingsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon_key.svg`
export const themeSettingsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/icon_tema.svg`

export const triggerSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/evento.svg`
export const commentRuleSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/comentario.svg`
export const ruleSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/regla.svg`
export const taskCreatedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/tarea creada.svg`
export const triggerStatusSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/estado inicial.svg`
export const expirationSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/expiracion.svg`
export const actionsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/acciones.svg`
export const attachSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/attach.svg`

export const notificationMailSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/notification-mail.svg`
export const notificationWebSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/notification-web.svg`
export const notificationMobileSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/notification-mobile.svg`
export const refreshSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/refresh-button.svg`
export const reloadSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/reload.svg`
export const ruleConditionsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/conditions.svg`

export const desAsociarSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/desasociar.svg`
export const caseTypeSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/tipodecaso.svg`
export const caseReasonSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/motivo.svg`
export const tasksUpdatedSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/tasks-updated.svg`

export const rightArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/right-arrow.svg`
export const leftArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/left-arrow.svg`

export const outlinedChevronSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/chevron-outlined.svg`
export const filledChevronSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/chevron-filled.svg`
export const actionSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/acciones.svg`

export const showSideBarSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/show-sidebar.svg`
export const finalStatusSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/final-status.svg`
export const initialStatusSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/initial-status.svg`
export const toolsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/tools.svg`

export const expandImageSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/expand.svg`
export const trash2SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/trash.svg`
export const trainingPhrasesSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/trainning-listen.svg`
export const intentSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/intent.svg`
export const responseItemSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/response-item.svg`
export const intentActionsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/intent-actions.svg`
export const intentActionsItemSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/intent-actions-item.svg`
export const closePopupSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/close-popup.svg`
export const hideRightAtrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/hide-right-arrow.svg`
export const inspectionSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/check-icon.svg`
export const newTabSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/open-tab.svg`
export const gotToArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/go-to-arrow.svg`
export const contactDataSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/contact-data.svg`
export const downArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/down_arrow.svg`

//arrows for fold and unfold content in cases table
export const unFoldArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/un-fold-arrow.svg`

export const grayArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/gray-arrow.svg`
export const redArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/red-arrow.svg`
export const greenArrowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/green-arrow.svg`

export const googleSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/google.svg`

export const priorityLowSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/priority-low.svg`
export const priorityMediumSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/priority-medium.svg`
export const priorityHighSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/priority-high.svg`

//softphone
export const dialPadSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/dialpad.svg`
export const phoneSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/phone.svg`
export const phoneCallingSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/phone-calling.svg`
export const connectSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/connect.svg`
export const disconnectSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/disconnect.svg`
export const deleteSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/dial-pad-delete.svg`
export const transferCallIcon = `${process.env.PUBLIC_URL || ''}/assets/icons/transfer_call.svg`
export const pauseCallIcon = `${process.env.PUBLIC_URL || ''}/assets/icons/pause_call.svg` 

export const deleteTagSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/delete-tag.svg`
export const transactionSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/transaction.svg`
export const curlyBracesSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/curly-braces.svg`
export const chevronSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/chevron.svg`
export const botV2SVG = `${process.env.PUBLIC_URL || ''}/assets/icons/bot.svg`
export const htmlSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/html.svg`
export const checkBlue = `${process.env.PUBLIC_URL || ''}/assets/icons/check-blue.svg`
export const qrSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/qr.svg`

export const addSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/burguer-menu.svg`
export const formsSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/forms.svg`
export const templateNewSVG = `${process.env.PUBLIC_URL || ''}/assets/icons/templates-new.svg`

//Empy states
export const emptyStateStatisticsSVG =
	`${process.env.PUBLIC_URL || ''}/assets/images/empty-state-estadisticas.svg`
